import { useTranslation } from "react-i18next";

import { SummaryBox } from "@app/dashboard/components/inner_layout/Cards/SummaryBox";
import { NO_VALUE } from "../../../utils";
import styles from "./customer-details.module.scss";


export const CustomerDetails = ({
  name,
  email,
  address
}: {
  name?: string,
  email?: string,
  address?: string,
}) => {
  const { t } = useTranslation();

  const ITEMS_LIST = [
    {
      label: t('innerLayout.disputesPage.disputeDetails.detailsBoxes.customerDetails.fields.name'),
      value: name || NO_VALUE,
    },
    {
      label: t('innerLayout.disputesPage.disputeDetails.detailsBoxes.customerDetails.fields.email'),
      value: email || NO_VALUE,
    },
    {
      label: t('innerLayout.disputesPage.disputeDetails.detailsBoxes.customerDetails.fields.address'),
      value: address ? { text: <div className={styles["customer-details__value"]}>{address}</div> } : NO_VALUE as any,
    },
  ];


  return (
    <div className={styles["customer-details"]}>
      <SummaryBox
        title={t('innerLayout.disputesPage.disputeDetails.detailsBoxes.customerDetails.title')}
        width="100%"
        height="fit-content"
        itemsList={ITEMS_LIST}
      />
    </div>
  )
}
